import { render, staticRenderFns } from "./captureLead.vue?vue&type=template&id=62bf8974"
import script from "./captureLead.vue?vue&type=script&lang=ts"
export * from "./captureLead.vue?vue&type=script&lang=ts"
import style0 from "./captureLead.vue?vue&type=style&index=0&id=62bf8974&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports